import { useState, useCallback } from 'react';

export interface SideDrawerControls {
    isOpen: boolean;
    open: () => void;
    close: () => void;
    toggle: () => void;
}

/**
 * Hook for managing side drawer state.
 *
 * @param {boolean} initialState - Initial open state (default: false)
 * @returns Object with isOpen state and control functions
 */
export const useSideDrawer = (initialState: boolean = false): SideDrawerControls => {
    const [isOpen, setIsOpen] = useState(initialState);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen(prev => !prev), []);

    return {
        isOpen,
        open,
        close,
        toggle,
    };
};
